export type ResidenceType = 'condo' | 'cooperative' | 'freehold' | null | undefined;

export function getResidenceTypeLabel(type: ResidenceType): string {
  if (type === 'condo') return 'Sameiet';
  if (type === 'cooperative') return 'Borettslag';
  if (type === 'freehold') return 'Selveier';
  return 'Bofellesskapet';
}
